<template>
    <section class="comp_settings_price_mask">
        <div class="wrp_comp_body" v-on:scroll="handleGlobalScroll($event)">
            <div class="mod--row mod--row-4">
                <div class="col col--12" v-for="dateString in priceMaskDates()">
                    <div
                        :class="`elm_nav_item elm_item mod--row mod--row-flex ${!newPriceMaskMap.get(dateString)?'required':''}`">
                        <div class="col">
                            <div class="part_ui_input">
                                <span
                                    style="font-weight: 400; color: #5e544a !important; margin-right: 50px">
                                    {{ moment(dateString).format('DD.MM.YYYY') }}
                                </span>
                            </div>
                        </div>
                        <div class="col"><span>{{ dayFromDate(dateString) }}</span></div>
                        <div class="col mod--flex-grow mod--right">
                            <div class="part_ui_input"><input type="number" min="0" step="0.01"
                                                              :value="newPriceMaskMap.get(dateString)"
                                                              :disabled="disabled"
                                                              v-on:change="changePrice(dateString, $event)"/>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="elm_button mod--mt-24" style="display:flex;justify-content: center">
                    <button type="submit" class="part_ui_btn part_ui_btn_primary mod--block" style="max-width: 300px;"
                            v-on:click="save">
                        <span>{{ $t(disabled ? 'ok' : 'save_prices') }}</span>
                    </button>
                </div>
            </div>
        </div>
    </section>
</template>

<script>

import moment from 'moment/moment';

export default {
    props: ['priceMaskMap', 'from', 'to', 'onChange', 'onClose'],
    data: function () {
        return {
            moment,
            newPriceMaskMap: new Map()
        }
    },
    computed: {
        disabled: function () {
            return !this.onChange
        }
    },
    watch: {
        priceMaskMap: function () {
            this.resetPriceMask()
        }
    },
    mounted() {
        this.resetPriceMask()
    },
    methods: {
        resetPriceMask() {
            this.newPriceMaskMap = new Map(this.priceMaskMap)
        },
        save() {
            if (this.onChange) {
                if (this.priceMaskDates().some(d => !this.newPriceMaskMap.get(moment(d).format('YYYY-MM-DD')))) {
                    this.$dialog.alert(this.$t('fill_all_prices'), {okText: 'Ok'})
                } else {
                    this.onChange(this.newPriceMaskMap)
                }
            } else {
                this.onClose()
            }
        },
        changePrice(dateString, event) {
            const newMap = new Map(this.newPriceMaskMap)
            newMap.set(dateString, event.target.value)
            this.newPriceMaskMap = newMap;
        },
        priceMaskDates() {
            const ret = [];

            if (this.from && this.to) {
                let from = new moment(this.from);
                let to = new moment(this.to);

                for (let m = moment(from); m.isBefore(to); m.add(1, 'days')) {
                    ret.push(moment(m).format('YYYY-MM-DD'))
                }
            }

            return ret;
        },
        dayFromDate(date) {
            return moment(date).format('dddd').toLowerCase();
        },
    }
}
</script>

<style scoped lang="less">

</style>



// WEBPACK FOOTER //
// src/templates/part/price-mask-edit.vue